export default __webpack_public_path__ + "static/media/empty.2402d58c.png";